import { useTranslation } from 'react-i18next';
import { PostingHabits, InfluencerAvatar } from '@anytag/shared-molecules';
import { TextCutter, BaseModal, BaseModalProps } from '@anytag/shared-atoms';

export interface AnalyticsComparePostsHabitModalProps extends BaseModalProps {
  account?: { name?: string; avatar?: string };
  data?: readonly {
    hour: number;
    weekday: number;
    averageLikes: number;
    engagementRate: number;
    averageComments: number;
  }[];
}

export const AnalyticsComparePostsHabitModal = ({
  footer,
  account,
  onClose,
  data = [],
  ...restProps
}: AnalyticsComparePostsHabitModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      onClose={onClose}
      footer={{ ...footer, cancelButton: { onClick: onClose, ...footer?.cancelButton } }}
      title={
        account ? (
          <div className="flex items-center">
            <InfluencerAvatar size="24px" src={account?.avatar} className="mr-2 rounded-full" />
            <TextCutter lines={1} text={t('Dialog.PostingHabits', { name: account?.name })} />
          </div>
        ) : undefined
      }
      {...restProps}
    >
      <PostingHabits header="" data={data} className="min-h-71" />
    </BaseModal>
  );
};
